import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold } from "@discovery/prelude/lib/control/lens";
import { ThumbnailType } from "../../components/molecules/thumbnail/image";
import { _PrimaryChannelTitleShow, _Show2Genres } from "./optics";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config } from "@discovery/common-dplus/lib/state";
import { _ShowsCollection } from "../optics";
const ShowPageView = React.lazy(() => import("./view"));
const getProps = (data) => {
    const showM = Fold.preview(_ShowsCollection, data);
    const genre = Fold.toArray(_Show2Genres, data);
    const primaryChannelTitleM = Fold.preview(_PrimaryChannelTitleShow, data);
    return {
        showM,
        genre,
        primaryChannelTitleM,
    };
};
const Shows = ({ showM, genre, primaryChannelTitleM, environment, }) => {
    const [configM] = useGlobalState(_Config);
    const parentalLockM = M.chain((x) => x.parentalLock, configM);
    const minimumAgeM = M.chain((x) => x.minimumAge, parentalLockM);
    const ageConstraint = M.fromMaybe(minimumAgeM, 0);
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(ShowPageView, { showVideoM: showM, thumbnailType: ThumbnailType.BASIC, read: environment, genre: genre, ageConstraint: ageConstraint, primaryChannelTitleM: primaryChannelTitleM })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, Shows);

